module.exports = __webpack_public_path__ + "static/media/contact-bg-ie.1b78eb05.jpg";